import { render, staticRenderFns } from "./CertificateBlankSave.vue?vue&type=template&id=5d408a41&scoped=true&"
import script from "./CertificateBlankSave.vue?vue&type=script&lang=js&"
export * from "./CertificateBlankSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d408a41",
  null
  
)

export default component.exports